// components/icons/PlusIcon.tsx
import React from "react";

export default function PlusIcon({
    color = "#851BED",
    rotate = false,
}: {
    color?: string;
    rotate?: boolean;
}) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`transition-transform duration-300 ${
                rotate ? "rotate-45" : "rotate-0"
            }`}
        >
            <line
                x1="12"
                y1="5"
                x2="12"
                y2="19"
                stroke={color}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line
                x1="5"
                y1="12"
                x2="19"
                y2="12"
                stroke={color}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
